import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'

interface InvalidTickerMessageProps {
  message: string
  ticker: string
}

export const InvalidTickerMessage: React.FC<InvalidTickerMessageProps> = ({
  message,
  ticker,
}) => {
  return (
    <>
      <IdeyaTypography.Text type={'danger'}>{message}</IdeyaTypography.Text>
      <a
        type={'link'}
        href={`mailto:support@polymerideya.com?subject=Requesting to make ${ticker} active`}
      >
        {' '}
        Email support
      </a>
    </>
  )
}
